import {Alert} from "@/components/alert/Alert.tsx";

import styles from "./CheckOutput.module.css";

export const CheckOutput = ({output}: {output: string}) => {
  return (
    <Alert>
      <code className={styles.alertOutput}>{output}</code>
    </Alert>
  );
};
